<!-- Start Page Title Area -->
<div id="bg-cover" class="page-title-area page-title-style-two lightgray-bg jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li>{{lessonsText}}</li>
            </ul>
            <h2>{{lessonsText}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Courses Area -->
<section class="courses-area ptb-100">
    <div class="container">

        <div class="courses-topbar">
            <div class="row align-items-center">
                <!-- <div class="col-lg-4 col-md-4">
                    <div class="topbar-result-count">
                        <p>Showing 1 – 6 of 54</p>
                    </div>
                </div> -->

                <div class="col-lg-12 col-md-12">

                    <div class="topbar-ordering-and-search">
                        <div class="row align-items-center">
                            <div class="col-lg4 col-md-4">
                                <div class="topbar-ordering">
                                    <select [disabled]="lessons.length === 0" class="form-control"
                                        (change)="onChangeLesson()" [(ngModel)]="currentLesson">
                                        <option *ngFor="let lesson of lessons" [ngValue]="lesson">{{translate(lesson.nameEn,lesson.nameKh)}}
                                        </option>
                                    </select>

                                </div>
                            </div>

                            <div class="col-lg4 col-md-4">
                                <div class="topbar-ordering">
                                    <select class="form-control" [disabled]="currentLesson.levels.length === 0"
                                        (change)="onChangeLevel()" [(ngModel)]="currentLevel">
                                        <option *ngFor="let level of currentLesson.levels" [ngValue]="level">
                                            {{translate(level.titleEn,level.titleKh)}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4">
                                <div class="topbar-search">
                                    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
                                        <label><i class="bx bx-search"></i></label>
                                        <input type="text" class="input-search" formControlName="searchText" placeholder="{{searchHere}}">
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <h6 *ngIf="isNoResult" class="text-center">No Courses founded.</h6>


        <app-small-spinner [show]="showSpinner"></app-small-spinner>

        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let course of courses">
                <app-english-course-item [course]="course"></app-english-course-item>
            </div>
        </div>
        <!-- Loading More -->
        <div
            *ngIf="loadingMore"
            class="course-loader"
        >
            <div class="loader-spinner">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div class="loader-text">
                <strong>Loading more courses</strong>
                <small>Please wait a moment...</small>
            </div>
        </div>

        <!-- No More Courses -->
        <div
            *ngIf="!hasNextPage && courses.length > 0"
            class="no-more-courses"
        >
            <div class="no-more-line"></div>

            <div class="no-more-content">
                <i class="fa fa-check-circle"></i>
                <span>You've reached the end</span>
            </div>

            <div class="no-more-line"></div>
        </div>
    </div>
</section>
<!-- End Courses Area -->